var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 28C4 14.7452 14.7452 4 28 4C41.2548 4 52 14.7452 52 28C52 41.2548 41.2548 52 28 52C14.7452 52 4 41.2548 4 28Z",
    fill: "#ED5367"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9988 23.9992V27.9992M27.9988 31.9992H28.0088M26.2888 18.8592L17.8188 32.9992C17.6442 33.3017 17.5518 33.6445 17.5508 33.9937C17.5498 34.343 17.6403 34.6864 17.8132 34.9898C17.9862 35.2931 18.2355 35.546 18.5365 35.7231C18.8375 35.9002 19.1796 35.9954 19.5288 35.9992H36.4688C36.818 35.9954 37.1601 35.9002 37.4611 35.7231C37.7621 35.546 38.0114 35.2931 38.1844 34.9898C38.3573 34.6864 38.4478 34.343 38.4468 33.9937C38.4458 33.6445 38.3534 33.3017 38.1788 32.9992L29.7088 18.8592C29.5305 18.5653 29.2795 18.3223 28.98 18.1537C28.6805 17.9851 28.3425 17.8965 27.9988 17.8965C27.6551 17.8965 27.3171 17.9851 27.0176 18.1537C26.7181 18.3223 26.4671 18.5653 26.2888 18.8592Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 48C16.9543 48 8 39.0457 8 28H0C0 43.464 12.536 56 28 56V48ZM48 28C48 39.0457 39.0457 48 28 48V56C43.464 56 56 43.464 56 28H48ZM28 8C39.0457 8 48 16.9543 48 28H56C56 12.536 43.464 0 28 0V8ZM28 0C12.536 0 0 12.536 0 28H8C8 16.9543 16.9543 8 28 8V0Z",
    fill: "#F6A9B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRed);
export default __webpack_public_path__ + "static/media/warning-red.ff96dce748cd0af81f3a0deb01878556.svg";
export { ForwardRef as ReactComponent };